import Link from '@eliadmin/core/src/components/link';

import type { PropsWithChildren } from 'react';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { getSafeHref, isRelativeHref } from '@eliadmin/core/src/utils/url-utils';

export type CategoryMenuProps = {
  className?: string;
};

export function CategoryMenu(props: PropsWithChildren<CategoryMenuProps>) {
  return (
    <ul className={cn('flex flex-row items-center gap-2', 'ea-category-menu', props.className)}>
      {props.children}
    </ul>
  );
}

export type CategoryMenuItemProps = {
  title: string;
  href?: string;
  onClick?: () => void;
  order?: number;
  className?: {
    root?: string;
    link?: string;
  };
};

export function CategoryMenuItem(props: CategoryMenuItemProps) {
  const LinkComp = props.href ? (isRelativeHref(getSafeHref(props.href)) ? Link : 'a') : 'span';

  return (
    <li
      style={{ order: props.order }}
      className={cn('flex flex-row', 'ea-category-menu-item', props.className?.root)}
    >
      <LinkComp
        {...(LinkComp === Link ? { prefetchOnHover: true } : {})}
        onClick={props.onClick}
        href={props.href ? getSafeHref(props.href) : ((undefined as any) ?? '#')}
        className={cn(
          'flex h-[60px] items-center justify-center rounded-[6px] px-2 text-sm font-bold text-black transition-all hover:bg-black/[0.03] hover:text-black xl:px-4',
          'ea-category-menu-item__link',
          props.className?.link,
        )}
      >
        {props.title}
      </LinkComp>
    </li>
  );
}
